import script from "./Chains.vue?vue&type=script&setup=true&lang=ts"
export * from "./Chains.vue?vue&type=script&setup=true&lang=ts"

import "./Chains.vue?vue&type=style&index=0&id=8f3d4774&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f3d4774"]])

export default __exports__